var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX2024(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0477 18.8577L12.1714 8.86799L11.394 7.73818L6.47536 0.592201L6.06766 0H0.0236816L1.49779 2.14215L8.03792 11.6447L8.81532 12.7733L14.0702 20.4083L14.4779 21H20.522L19.0479 18.8578L19.0477 18.8577ZM15.196 19.6326L9.73662 11.7006L8.95922 10.5715L2.62432 1.36735H5.34935L10.4725 8.81098L11.2499 9.9401L17.9212 19.6326H15.1962H15.196Z",
    fill: "#004B81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95938 10.5713L9.73677 11.7004L8.81513 12.773L1.74378 20.9996H0L8.03773 11.6444L8.95938 10.5713Z",
    fill: "#004B81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7942 0L12.1716 8.86799L11.2499 9.93993L10.4725 8.81081L11.3942 7.73818L16.5576 1.72823L18.0504 0H19.7942Z",
    fill: "#004B81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2024);
export default __webpack_public_path__ + "static/media/X 2024.4d1bd228.svg";
export { ForwardRef as ReactComponent };